(()=>{
 'use strict';
 const cleanups=new Map();
 function init(scope=document){
  scope.querySelectorAll('[data-ah-reviews]').forEach(root=>{
   if(cleanups.has(root))return;
   let dispose=()=>{},observer;
   const setup=()=>{
    const native=root.querySelector('.jdgm-carousel__item-container');
    const track=native||root.querySelector('.ah-review-track');
    const cards=Array.from(root.querySelectorAll(native?'.jdgm-carousel-item':'.ah-review-card'));
    if(!track||!cards.length)return false;
    const controls=root.querySelector('.ah-review-controls');
    const previous=root.querySelector('[data-ah-previous]');
    const next=root.querySelector('[data-ah-next]');
    const position=root.querySelector('[data-ah-position]');
    root.classList.add('ah-reviews-ready');
    track.tabIndex=0;
    track.setAttribute('aria-label',root.querySelector('h2').textContent);
    let frame=0;
    const update=()=>{
     frame=0;
     controls.hidden=track.scrollWidth<=track.clientWidth+4;
     const left=track.getBoundingClientRect().left;
     const current=cards.reduce((best,card,index)=>Math.abs(card.getBoundingClientRect().left-left)<Math.abs(cards[best].getBoundingClientRect().left-left)?index:best,0);
     previous.disabled=track.scrollLeft<=2;
     next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
     const visible=cards.filter(card=>{const rect=card.getBoundingClientRect();return rect.left>=left-2&&rect.right<=left+track.clientWidth+2;}).length;
     const last=Math.min(cards.length,current+Math.max(1,visible));
     position.textContent=last>current+1?`${current+1}–${last} / ${cards.length}`:`${current+1} / ${cards.length}`;
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const move=direction=>{
     const amount=cards.length>1?cards[1].getBoundingClientRect().left-cards[0].getBoundingClientRect().left:cards[0].getBoundingClientRect().width;
     track.scrollBy({left:direction*amount,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    };
    const prev=()=>move(-1),following=()=>move(1);
    previous.addEventListener('click',prev);next.addEventListener('click',following);
    track.addEventListener('scroll',schedule,{passive:true});
    const preserveScroll=event=>event.stopImmediatePropagation();
    const touchEvents=['touchstart','touchmove','touchend'];
    if(native)touchEvents.forEach(event=>track.addEventListener(event,preserveScroll,{capture:true,passive:true}));
    const resize=new ResizeObserver(schedule);resize.observe(track);
    update();
    dispose=()=>{if(native)touchEvents.forEach(event=>track.removeEventListener(event,preserveScroll,true));resize.disconnect();track.removeEventListener('scroll',schedule);previous.removeEventListener('click',prev);next.removeEventListener('click',following);cancelAnimationFrame(frame);root.classList.remove('ah-reviews-ready');};
    return true;
   };
   if(!setup()){observer=new MutationObserver(()=>{if(setup())observer.disconnect();});observer.observe(root,{childList:true,subtree:true});}
   cleanups.set(root,()=>{observer?.disconnect();dispose();});
  });
 }
 init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const [root,cleanup] of cleanups){if(event.target.contains(root)){cleanup();cleanups.delete(root);}}});
 document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.ah-review-card');if(card)card.scrollIntoView({behavior:'instant',block:'nearest',inline:'start'});});
})();
